import { render } from "./itemHistoryAdd.vue?vue&type=template&id=61d26da3&scoped=true&ts=true"
import script from "./itemHistoryAdd.vue?vue&type=script&lang=ts&config=true"
export * from "./itemHistoryAdd.vue?vue&type=script&lang=ts&config=true"

import "./itemHistoryAdd.vue?vue&type=style&index=0&id=61d26da3&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61d26da3"]])

export default __exports__